<script type="ts">
	import type { IThemedToken } from 'shiki';
	import Code from './Editor/Code.svelte';

	export let code: IThemedToken[][] | string | JSON;
</script>

<div class="code-wrapper minicode">
	<div class="code-wrapper__inner">
		<Code {code} />
	</div>
</div>
